// Product data with detailed technical specifications

export const productData = {
  'upvc-agriculture-pipes': {
    id: 'upvc-agriculture-pipes',
    name: 'UPVC Agriculture Pipes & Fittings',
    subtitle: 'High-quality rigid UPVC pipes for water supply and irrigation',
    standard: 'IS 4985',
    range: '20mm to 250mm',
    image: 'https://customer-assets.emergentagent.com/job_dharani-pipes/artifacts/gb9eiulb_Gemini_Generated_Image_9lu28f9lu28f9lu2.png',
    catalogUrl: 'https://customer-assets.emergentagent.com/job_dharani-pipes/artifacts/rutdbfhk_UPVC%20Agriculture%20%20BROUCHER.pdf',
    description: 'Dharani UPVC rigid pipes are manufactured as per IS 4985:2000 standards with stringent quality control. These pipes are ideal for water supply, irrigation, and industrial applications, available in various pressure ratings from 2.5 to 12.5 kgf/cm². Standard length: 6 meters.',
    features: [
      'Smooth internal surface for maximum flow',
      '100% hygienic water supply',
      'Prevents bacterial growth',
      'Durability and lightweight design',
      'Easy handling and installation',
      'Maintenance free operation',
      'Chemical and corrosion resistance',
      'Lower electricity costs',
      'Non-toxic and long service life'
    ],
    specifications: {
      text: 'Dimensions as per IS 4985:2000. Available in various pressure classes suitable for different applications. We also manufacture pipes to confirm pressure ratings of 3.5 kgf/cm² and 3.0 kgf/cm². Standard length: 6 meters.',
      table: {
        headers: ['Nominal OD (mm)', 'Wall Thickness (mm) for Pressure Rating', '', '', '', '', ''],
        rows: [
          ['', '2.5 kgf/cm²', '4.0 kgf/cm²', '6.0 kgf/cm²', '8.0 kgf/cm²', '10.0 kgf/cm²', '12.5 kgf/cm²'],
          ['20', '', '', '', '1.2', '1.4', '1.7'],
          ['25', '', '', '', '1.5', '1.8', '2.2'],
          ['32', '', '', '1.4', '1.8', '2.2', '2.8'],
          ['40', '', '1.4', '1.7', '2.3', '2.8', '3.4'],
          ['50', '', '1.5', '2.2', '2.8', '3.5', '4.3'],
          ['63', '1.5', '2.0', '2.6', '3.4', '4.2', '5.1'],
          ['75', '1.8', '2.3', '3.1', '4.0', '5.0', '6.1'],
          ['90', '2.0', '2.6', '3.7', '4.9', '6.1', '7.5'],
          ['110', '1.6', '2.5', '3.7', '4.9', '6.1', '7.5'],
          ['125', '1.8', '2.9', '4.3', '5.6', '6.9', '8.5'],
          ['140', '2.0', '3.2', '4.8', '6.3', '7.7', '9.5'],
          ['160', '2.3', '3.7', '5.4', '7.2', '8.8', '10.9'],
          ['180', '2.6', '4.2', '6.1', '8.0', '9.9', '12.2'],
          ['200', '2.9', '4.6', '6.8', '8.9', '11.0', '13.6']
        ]
      },
      additionalInfo: [
        'All dimensions are in millimeters',
        'Minimum wall thickness values shown',
        'Pipes tested for pressure, dimension, and other critical parameters',
        'Selection charts available for pipe diameter and pressure class selection',
        'Standard length: 6 meters'
      ]
    },
    applications: [
      {
        title: 'Potable Water Supply',
        description: 'Safe drinking water distribution for residential and commercial buildings'
      },
      {
        title: 'Sewage and Drainage',
        description: 'Efficient wastewater management and drainage systems'
      },
      {
        title: 'Sprinkler & Drip Irrigation',
        description: 'Modern irrigation systems for agriculture'
      },
      {
        title: 'Agriculture Systems',
        description: 'Farm irrigation and water distribution networks'
      },
      {
        title: 'Rain Water Harvesting',
        description: 'Sustainable water collection and storage systems'
      },
      {
        title: 'Industrial Applications',
        description: 'Chemical and fluid transportation in industrial facilities'
      }
    ],
    advantages: [
      {
        title: 'Superior Flow Rate',
        description: 'Smooth internal surface ensures maximum water flow with minimal friction loss'
      },
      {
        title: 'Cost Effective',
        description: 'Lower installation and operational costs compared to traditional materials'
      },
      {
        title: 'Corrosion Resistance',
        description: 'Immune to chemical, electrolytic, and environmental corrosion'
      },
      {
        title: 'Lightweight Design',
        description: 'Easy to transport, handle, and install, reducing labor costs'
      },
      {
        title: 'Long Service Life',
        description: 'Durable construction ensures decades of trouble-free operation'
      },
      {
        title: 'Eco-Friendly',
        description: 'Non-toxic material safe for potable water and environment'
      }
    ]
  },

  'swr-pipes': {
    id: 'swr-pipes',
    name: 'SWR Pipes (Soil, Waste & Rainwater)',
    subtitle: 'Efficient drainage solutions for buildings',
    standard: 'IS 13592',
    range: '40mm to 200mm',
    image: 'https://customer-assets.emergentagent.com/job_dharani-pipes/artifacts/742f2j7z_WhatsApp%20Image%202026-03-14%20at%207.58.27%20PM.jpeg',
    catalogUrl: null,
    description: 'Dharani SWR pipes are designed for efficient drainage of soil, waste water, and rainwater in residential and commercial buildings. Available in Type A (ventilation/rainwater) and Type B (soil/waste) configurations as per IS 13592:2013. Standard lengths: 3 meters and 6 meters.',
    features: [
      'Smooth interior surface',
      'Chemical resistant',
      'Noise reduction',
      'Maintenance free',
      'Leak-proof jointing',
      'UV stabilized',
      'Impact resistant',
      'Easy installation'
    ],
    specifications: {
      text: 'Available in Type A (thinner walls for ventilation and rainwater) and Type B (thicker walls for soil and waste discharge). Standard lengths: 3 meters and 6 meters.',
      table: {
        headers: ['Nominal OD (mm)', 'Mean OD Range (mm)', 'Type A Wall (mm)', 'Type B Wall (mm)'],
        rows: [
          ['40', '40.0 - 40.3', '1.40 - 1.80', '1.90 - 2.30'],
          ['50', '50.0 - 50.3', '1.40 - 1.80', '1.90 - 2.40'],
          ['75', '75.0 - 75.3', '1.80 - 2.20', '2.30 - 2.80'],
          ['90', '90.0 - 90.3', '1.90 - 2.30', '2.40 - 2.90'],
          ['110', '110.0 - 110.4', '2.20 - 2.70', '2.70 - 3.20'],
          ['160', '160.0 - 160.5', '2.80 - 3.50', '3.50 - 4.20'],
          ['200', '200.0 - 200.6', '3.50 - 4.20', '4.40 - 5.30']
        ]
      },
      additionalInfo: [
        'Conforms to IS 13592:2013 standards',
        'Fittings conform to IS 14735',
        'Density: 1.350–1.460 kg/m³ at 23°C',
        'Tensile strength: Minimum 45 MPa',
        'Joint types: Selfit (solvent cement) or Integrated Rubber Ring',
        'Standard lengths: 3 meters and 6 meters'
      ]
    },
    applications: [
      {
        title: 'Building Drainage Systems',
        description: 'Complete drainage solutions for multi-story buildings'
      },
      {
        title: 'Sanitary Installations',
        description: 'Soil and waste discharge from toilets and bathrooms'
      },
      {
        title: 'Rainwater Harvesting',
        description: 'Rainwater collection and drainage systems'
      },
      {
        title: 'Waste Water Disposal',
        description: 'Safe disposal of domestic and commercial wastewater'
      },
      {
        title: 'Ventilation Systems',
        description: 'Drainage stack ventilation pipes'
      },
      {
        title: 'Underground Drainage',
        description: 'Below-ground drainage connections'
      }
    ],
    advantages: [
      {
        title: 'Noise Reduction',
        description: 'Special formulation reduces water flow noise significantly'
      },
      {
        title: 'Chemical Resistance',
        description: 'Resistant to domestic chemicals and sewage'
      },
      {
        title: 'Leak-Proof Joints',
        description: 'Rubber ring or solvent cement joints ensure no leakage'
      },
      {
        title: 'UV Protection',
        description: 'Can be used in exposed outdoor installations'
      },
      {
        title: 'Fast Installation',
        description: 'Quick and easy jointing systems save time'
      },
      {
        title: 'Maintenance Free',
        description: 'No scaling or clogging, requires minimal maintenance'
      }
    ]
  },

  'electric-conduits': {
    id: 'electric-conduits',
    name: 'Electric Conduits',
    subtitle: 'Safe electrical wiring protection',
    standard: 'IS 9535',
    range: '16mm, 20mm, 25mm (Group I)',
    image: 'https://customer-assets.emergentagent.com/job_dharani-pipes/artifacts/l6czzc4r_Gemini_Generated_Image_j99ajbj99ajbj99a.png',
    catalogUrl: null,
    description: 'Dharani PVC electrical conduits provide superior protection for electrical wiring in residential, commercial, and industrial installations. Manufactured to IS 9535 standards with fire retardant properties. Group I conduits available in 16mm, 20mm, and 25mm sizes up to 3 meters length.',
    features: [
      'Fire retardant (UL94 V0)',
      'Impact resistant',
      'Weather proof',
      'UV stabilized',
      'Non-conductive',
      'Corrosion resistant',
      'Easy to install',
      'Cost effective'
    ],
    specifications: {
      text: 'Rigid PVC conduits manufactured from virgin PVC resin. Operating temperature: -25°C to +65°C. Group I conduits available in 16mm, 20mm, and 25mm sizes. Standard length: 3 meters only.',
      table: {
        headers: ['Trade Size', 'Nominal Size', 'Standard Length', 'Application'],
        rows: [
          ['Group I', '16mm', '3 meters', 'Light duty electrical wiring'],
          ['Group I', '20mm', '3 meters', 'Standard electrical installations'],
          ['Group I', '25mm', '3 meters', 'Medium duty wiring protection']
        ]
      },
      additionalInfo: [
        'Conforms to IS 9535 standards',
        'Fire rating: UL94 V0/M1',
        'Compression resistance: Minimum 320 N/5 cm',
        'Impact resistance: 2 Joule',
        'Standard length: 3 meters',
        'Group I sizes only: 16mm, 20mm, 25mm'
      ]
    },
    applications: [
      {
        title: 'Electrical Wiring Protection',
        description: 'Safe enclosure for building electrical wiring'
      },
      {
        title: 'Cable Management',
        description: 'Organized routing of electrical cables'
      },
      {
        title: 'Outdoor Installations',
        description: 'Weather-resistant conduits for outdoor wiring'
      },
      {
        title: 'Underground Cabling',
        description: 'Direct burial applications'
      },
      {
        title: 'Industrial Facilities',
        description: 'Chemical and moisture resistant wiring protection'
      },
      {
        title: 'Solar Installations',
        description: 'Solar panel and renewable energy wiring'
      }
    ],
    advantages: [
      {
        title: 'Fire Safety',
        description: 'Self-extinguishing material with UL94 V0 rating'
      },
      {
        title: 'Non-Conductive',
        description: 'Electrical insulation for maximum safety'
      },
      {
        title: 'Corrosion Proof',
        description: 'Immune to rust and chemical corrosion'
      },
      {
        title: 'Weather Resistant',
        description: 'UV stabilized for outdoor installations'
      },
      {
        title: 'Easy Installation',
        description: 'Lightweight and easy to cut, bend, and join'
      },
      {
        title: 'Cost Savings',
        description: 'Lower material and installation costs'
      }
    ]
  },

  'udg-pipes': {
    id: 'udg-pipes',
    name: 'UDG Pipes (Underground Drainage)',
    subtitle: 'Heavy-duty underground drainage systems',
    standard: 'IS 15328',
    range: '63mm to 250mm',
    image: 'https://customer-assets.emergentagent.com/job_dharani-pipes/artifacts/q5hdaleh_Gemini_Generated_Image_t19nayt19nayt19n.png',
    catalogUrl: 'https://customer-assets.emergentagent.com/job_dharani-pipes/artifacts/yw8emm3y_UGD%20BROUCHER.pdf',
    description: 'Dharani UPVC UGD pipes are manufactured as per IS 15328:2003 with latest amendments. Available in SN2, SN4, and SN8 stiffness classes for non-pressure gravity drainage applications including soil, waste, storm water, and industrial effluents.',
    features: [
      'Extra strength - High impact resistance',
      'High compressive strength for buried applications',
      'Elastomeric rubber rings for leak-proof joints',
      'High flow rate - smooth internal surface',
      'Light weight for easy handling',
      'Heat resistant and non-toxic',
      'Non-corrosive and chemically resistant',
      'Rodent resistant',
      'Cost effective system'
    ],
    specifications: {
      text: 'Available in three stiffness classes: SN2 (SDR 51, Series S25), SN4 (SDR 41, Series S20), and SN8 (SDR 34, Series S16.5). Pipes supplied with sliding sockets for solvent cement welding and grooved sockets with elastomeric rubber ring jointing. Standard length: 6 meters.',
      table: {
        headers: ['Diameter (mm)', 'SN2 Wall (mm)', 'SN4 Wall (mm)', 'SN8 Wall (mm)'],
        rows: [
          ['63', '-', '-', '2.70 - 3.10'],
          ['75', '-', '-', '2.80 - 3.30'],
          ['90', '-', '-', '2.90 - 3.40'],
          ['110', '-', '-', '3.20 - 3.70'],
          ['160', '3.20 - 3.70', '4.00 - 4.60', '4.70 - 5.40'],
          ['200', '3.90 - 4.50', '4.90 - 5.60', '5.90 - 6.70'],
          ['250', '4.90 - 5.60', '6.20 - 7.00', '7.30 - 8.30']
        ]
      },
      additionalInfo: [
        'Conforms to IS 15328:2003',
        'Nominal Ring Stiffness: SN2 (2 kN/m²), SN4 (4 kN/m²), SN8 (8 kN/m²)',
        'Embedded with elastomeric rubber rings',
        'Long life and heat resistant properties',
        'Non-toxic and non-conductive to electricity',
        'Standard length: 6 meters'
      ]
    },
    applications: [
      {
        title: 'Municipal Drainage',
        description: 'City-wide underground drainage networks'
      },
      {
        title: 'Sewerage Systems',
        description: 'Transportation of soil and waste discharge'
      },
      {
        title: 'Storm Water Management',
        description: 'Rainwater collection and drainage'
      },
      {
        title: 'Underground Installations',
        description: 'Buried drainage for roads and infrastructure'
      },
      {
        title: 'Industrial Effluents',
        description: 'Safe disposal of industrial liquid waste'
      },
      {
        title: 'Land Drainage',
        description: 'Agricultural and land drainage systems'
      }
    ],
    advantages: [
      {
        title: 'Superior Crush Resistance',
        description: 'High ring stiffness for deep burial applications'
      },
      {
        title: 'Leak-Proof System',
        description: 'Elastomeric rubber ring joints prevent infiltration'
      },
      {
        title: 'High Flow Capacity',
        description: 'Smooth interior ensures efficient drainage'
      },
      {
        title: 'Chemical Resistant',
        description: 'Withstands harsh sewage and industrial effluents'
      },
      {
        title: 'Easy Installation',
        description: 'Lightweight design reduces labor and equipment costs'
      },
      {
        title: 'Cost Effective',
        description: 'Lower total cost compared to concrete or stoneware'
      }
    ]
  },

  'upvc-plumbing-pipes': {
    id: 'upvc-plumbing-pipes',
    name: 'UPVC Plumbing Pipes',
    subtitle: 'Premium quality pipes for water distribution',
    standard: 'ASTM 1785',
    range: 'Schedule 40 & 80 (up to 4")',
    image: 'https://customer-assets.emergentagent.com/job_dharani-pipes/artifacts/pn57daeh_Gemini_Generated_Image_b8u3axb8u3axb8u3.png',
    catalogUrl: null,
    description: 'Dharani UPVC plumbing pipes manufactured as per ASTM D1785 standards. Available in Schedule 40 and 80 for various pressure applications up to 4 inches. NSF certified material safe for potable water systems. Standard length: 6 meters.',
    features: [
      'NSF certified material',
      'Pressure rated for various applications',
      'Leak-proof joints',
      'Chemical resistant',
      'Corrosion proof',
      'UV stabilized',
      'Easy to install',
      'Cost effective'
    ],
    specifications: {
      text: 'Available in Schedule 40 (general use) and Schedule 80 (high pressure) up to 4 inches only. Material: PVC 1120 with hydrostatic design stress of 3830 psi. Operating temperature: -20°C to +70°C. Standard length: 6 meters.',
      table: {
        headers: ['Nominal Size', 'OD (mm)', 'Sch 40 Wall (mm)', 'Sch 80 Wall (mm)'],
        rows: [
          ['½"', '21.34', '2.77', '3.73'],
          ['¾"', '26.67', '2.87', '3.91'],
          ['1"', '33.40', '3.38', '4.55'],
          ['1¼"', '42.16', '3.56', '4.85'],
          ['1½"', '48.26', '3.68', '5.08'],
          ['2"', '60.33', '3.91', '5.54'],
          ['3"', '88.90', '5.49', '7.62'],
          ['4"', '114.30', '6.02', '8.56']
        ]
      },
      additionalInfo: [
        'Conforms to ASTM D1785-21a',
        'Material: PVC 1120 compound per ASTM D1784',
        'Tensile strength: ≥48.3 MPa',
        'Impact strength: ≥34.7 J/m',
        'Standard length: 6 meters',
        'Available only up to 4 inches in Schedule 40 and 80'
      ]
    },
    applications: [
      {
        title: 'Residential Plumbing',
        description: 'Home water supply and distribution systems'
      },
      {
        title: 'Commercial Water Supply',
        description: 'Building water distribution networks'
      },
      {
        title: 'Hot & Cold Water Lines',
        description: 'Temperature-rated water distribution'
      },
      {
        title: 'Potable Water Systems',
        description: 'Safe drinking water distribution'
      },
      {
        title: 'Irrigation Systems',
        description: 'Agricultural and landscape irrigation'
      },
      {
        title: 'Industrial Piping',
        description: 'Chemical and fluid transportation'
      }
    ],
    advantages: [
      {
        title: 'NSF Certified',
        description: 'Safe for potable water with NSF/ANSI 61 certification'
      },
      {
        title: 'Pressure Rated',
        description: 'Various schedules for different pressure requirements'
      },
      {
        title: 'Corrosion Free',
        description: 'Never rusts, corrodes, or scales'
      },
      {
        title: 'Chemical Resistance',
        description: 'Resistant to acids, alkalis, and chlorine'
      },
      {
        title: 'Long Service Life',
        description: 'Decades of reliable operation'
      },
      {
        title: 'Easy Maintenance',
        description: 'Smooth interior prevents scaling and clogging'
      }
    ]
  },

  'casing-pipes': {
    id: 'casing-pipes',
    name: 'Casing Pipes for Borewell',
    subtitle: 'Robust pipes for borewell applications',
    standard: 'IS 12818',
    range: '100mm to 250mm',
    image: 'https://customer-assets.emergentagent.com/job_dharani-pipes/artifacts/pula3ot3_ChatGPT%20Image%20Mar%2014%2C%202026%2C%2005_49_28%20PM.png',
    catalogUrl: null,
    description: 'Dharani UPVC casing pipes for borewells manufactured as per IS 12818:2000. Available in Shallow Casing (up to 80m), Medium Casing (up to 250m), and Screen Casing types with threaded or plain ends. Sizes available from 100mm to 250mm. Standard length: 6 meters.',
    features: [
      'High tensile strength',
      'Quality threading',
      'Depth rated for various applications',
      'Corrosion proof',
      'Chemical resistant',
      'UV stabilized',
      'Easy installation',
      'Cost effective'
    ],
    specifications: {
      text: 'Available in three types: Shallow Casing (CS, up to 80m depth), Medium Casing (CM, up to 250m depth), and Screen Casing (ribbed/slotted for water filtration). Threaded connections for secure jointing. Sizes from 100mm to 250mm. Standard length: 6 meters.',
      table: {
        headers: ['Nominal Size', 'Shallow Casing (CS)', 'Medium Casing (CM)', 'Screen Casing'],
        rows: [
          ['', 'OD/Wall (mm)', 'OD/Wall (mm)', 'OD/Wall (mm)'],
          ['4" (100mm)', '113 / 5.0', '-', '117 / 5.0'],
          ['5" (125mm)', '-', '140 / 6.5', '144 / 6.5'],
          ['6" (150mm)', '165 / 5.7', '165 / 7.5', '169 / 7.5'],
          ['7" (175mm)', '-', '200 / 8.8', '204 / 8.8'],
          ['8" (200mm)', '225 / 7.6', '225 / 10.0', '229 / 10.0'],
          ['10" (250mm)', '280 / 9.6', '280 / 12.5', '284 / 12.5']
        ]
      },
      additionalInfo: [
        'Conforms to IS 12818:2000',
        'Density: 1.35-1.46 kg/m³',
        'Thread length: ~120mm',
        'Screen open area: 10-12% (for slotted variants)',
        'Standard length: 6 meters',
        'Available only up to 250mm (10 inches)',
        'Colors: Red/green (CS), Blue/off-white (CM), Blue/yellow (Screen)'
      ]
    },
    applications: [
      {
        title: 'Borewell Installations',
        description: 'Structural support for borewell walls'
      },
      {
        title: 'Water Well Casing',
        description: 'Protection and casing for water wells'
      },
      {
        title: 'Agricultural Wells',
        description: 'Irrigation well installations'
      },
      {
        title: 'Deep Well Drilling',
        description: 'Medium-depth borewell applications'
      },
      {
        title: 'Shallow Wells',
        description: 'Domestic and small-scale water extraction'
      },
      {
        title: 'Screen Applications',
        description: 'Water filtration in well systems'
      }
    ],
    advantages: [
      {
        title: 'Superior Strength',
        description: 'High tensile strength for deep well applications'
      },
      {
        title: 'Corrosion Resistance',
        description: 'Never rusts or deteriorates in groundwater'
      },
      {
        title: 'Quality Threading',
        description: 'Precision threads for leak-proof connections'
      },
      {
        title: 'Lightweight',
        description: 'Easy to transport and install'
      },
      {
        title: 'Cost Effective',
        description: 'Lower cost than steel with superior longevity'
      },
      {
        title: 'Maintenance Free',
        description: 'No painting or anti-corrosion treatment needed'
      }
    ]
  }
};

export const productList = Object.values(productData);
